// Imports


// Plugins
const plugins = [{
  location: "/app/node_modules/react-static-plugin-styled-components",
  plugins: [],
  hooks: {}
},
{
  location: "/app",
  plugins: [],
  hooks: {}
}]

// Export em!
export default plugins